import React, {useContext}  from 'react';
import { useCookies } from "react-cookie";
import { spotList } from './Spot/register/config';
import { Context } from '../store/reducer';

const RegisterMenu = () => {
    const { state, dispatch } = useContext(Context);
    const [cookies,setCookie,removeCookie] = useCookies(["spots", "latitude", "longitude"]);
    const spots = cookies.spots || []
    const register = (category) => {
        const latitude = JSON.parse(cookies.latitude);
        const longitude = JSON.parse(cookies.longitude);
        dispatch({
            type: 'SET_NEW_SPOT',
            category: category,
            latitude: latitude,
            longitude: longitude 
        })
    };

    return(
        <div className="spot-regist">
            <div className="spot-regist-inner">
                <dl className="spot-step">
                    <dt><span className="spot-step-num">1</span></dt>
                    <dd>登録するマークを押してください。</dd>
                </dl>
                <div className="spot-slider">
                    <ul className="spot-regist-icon-list">
                        {spotList.map(spot => (
                            <li key={spot.type}><button className="spot-regist-btn" onClick={() => register(spot.name)}><span className="spot-regist-btn_icon"><img src={spot.src} alt={spot.name}/></span><span className="spot-regist-btn_text">{spot.name}</span></button></li>
                        ))}
                    </ul>
                </div>
                <dl className="spot-step">
                    <dt><span className="spot-step-num">2</span></dt>
                    <dd>地図上に表示されたマークの位置を調節してください。マークをクリックしてスポット名等を入力し「登録する」ボタンを押すことで保存されます。<br className="u-hidden_sp" /><span className="spot-step-cmt">※1と2を繰り返すことで、複数登録が可能です</span></dd>
                </dl>

            </div>
        </div>
    )
}

export default RegisterMenu
